import React from "react";
import styled from "styled-components";
import GuideCorrect1 from "./assets/guide_1.png";
import GuideCorrect2 from "./assets/guide_2.png";
import GuideCorrect3 from "./assets/guide_3.png";
import { useTranslation } from "src/hooks";
import {
  Box,
  Button,
  Modal,
  ModalContent,
  ModalFooter,
  ModalManager,
  Text,
} from "../../../components";

export const ListContainerEl = styled.ul`
  list-style: disc;
  padding-left: 1em;
  font-family: ${(props) => props.theme.text.fontFamily.normal};
  line-height: ${(props) => props.theme.text.lineHeight.normal};
  color: ${(props) => props.theme.colors.text.soft};
`;

export const ListEl = styled.li`
  margin-bottom: ${(p) => p.theme.dimension.spacing.l}px;
  margin-left: ${(p) => p.theme.dimension.spacing.s}px;
`;

export const ImageContainerEl = styled(Box)`
  display: flex;
  margin-top: ${(p) => p.theme.dimension.spacing.xxl}px;
  gap: ${(p) => p.theme.dimension.spacing.l}px;
`;

type IGuideModalProps = {
  onClose: () => void;
  show: boolean;
};

export const GuideModal: React.FC<IGuideModalProps> = (props) => {
  const translate = useTranslation();
  const { onClose, show } = props;
  const path = "business_info.physical_business.guide";

  return (
    <>
      <ModalManager onClose={onClose} showModal={show}>
        <Modal fitWidth style={{ height: "auto" }}>
          <ModalContent>
            <Text marginBottomXxl marginTopS fontWeight="demi">
              {translate(`${path}.title`)}
            </Text>
            <ListContainerEl>
              <ListEl>{translate(`${path}.point_1`)}</ListEl>
              <ListEl>{translate(`${path}.point_2`)}</ListEl>
              <ListEl>{translate(`${path}.point_3`)}</ListEl>
            </ListContainerEl>
            <ImageContainerEl>
              <img src={GuideCorrect1} alt="correct selfie example" />
              <img src={GuideCorrect2} alt="incorrect selfie example 1" />
              <img src={GuideCorrect3} alt="incorrect selfie example 2" />
            </ImageContainerEl>
          </ModalContent>
          <ModalFooter alignLeft>
            <Button onClick={onClose}>{translate(`${path}.cta`)}</Button>
          </ModalFooter>
        </Modal>
      </ModalManager>
    </>
  );
};
